import React, { useState } from 'react';
import { object } from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './TableRowMenu.module.css';

const CreateEquipmentTableRowMenu = ({
    device,
    onCustomizeEquipmentModal,
    onUseExistingEquipmentModal,
    setDevice,
    updateDevice,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setDevice(device);
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleCustomizeEquipment() {
        onCustomizeEquipmentModal(true);

        handleClose();
    }

    function handleUseExistingEquipment() {
        onUseExistingEquipmentModal(true);

        handleClose();
    }

    function handleToggleExcludeEquipment(toggleState) {
        handleClose();

        setTimeout(() => {
            device.isExcluded = toggleState;
            updateDevice(device);
        }, 500);
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleCustomizeEquipment}>
                    <img
                        alt="equipment icon"
                        className={classes.contextIcon}
                        src="/assets/images/customizeEquipmentIconFlat.svg"
                    />
                    Customize Equipment
                </MenuItem>
                {
                    device.isExcluded &&
                    <MenuItem onClick={() => handleToggleExcludeEquipment(false)}>
                        <img
                            alt="include icon"
                            className={classes.contextIcon}
                            src="/assets/images/billing-ok.svg"
                        />
                        Include Equipment
                    </MenuItem>
                }
                {
                    !device.isExcluded &&
                    <MenuItem onClick={() => handleToggleExcludeEquipment(true)}>
                        <img
                            alt="exclude icon"
                            className={classes.contextIcon}
                            src="/assets/images/billing-on-hold.svg"
                        />
                        Exclude Equipment
                    </MenuItem>
                }
                <MenuItem onClick={handleUseExistingEquipment}>
                    <img
                        alt="equipment icon"
                        className={classes.contextIcon}
                        src="/assets/images/equipmentTreeIcon.svg"
                    />
                    Use Existing Equipment
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

CreateEquipmentTableRowMenu.defaultProps = {
    device: {}
};

CreateEquipmentTableRowMenu.propTypes = {
    device: object
};

export default CreateEquipmentTableRowMenu;
